// extracted by mini-css-extract-plugin
export default {"links":"browser-not-supported_links__I8g0D","link":"browser-not-supported_link__z86CR"};